import React from "react";

import './spiner.scss'

const Spiner = () => {
  return (
    <div className="cssload-container">
      <div className="cssload-circle-1">
        <div className="cssload-circle-2">
          <div className="cssload-circle-3">
            <div className="cssload-circle-4">
              <div className="cssload-circle-5">
                <div className="cssload-circle-6">
                  <div className="cssload-circle-7">
                    <div className="cssload-circle-8"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Spiner;
